import IconSearch from 'assets/icons/search.svg';
import useSynchoniseVariantImage from 'hooks/product/use-synchronise-variant-image';
import usePreventHorizontalScroll from 'hooks/slider/use-prevent-horizontal-scroll';
import { useProductDetailsHeaderState } from 'modules/product-details/components/product-details-header/state';
import { Variant } from 'modules/product-details/types';
import Image from "next/image";
import { useRef } from 'react';
import Slider from 'react-slick';
import { generalImageLoader } from 'utils/image-loader';
import CarouselSelector from '../carousel-selector';
import { ProductGallery } from '../product-details-header';

interface Props {
  selectedGalleryItemIndex: number;
  svgLayerIndex?: number;
  productGallery: ProductGallery[];
  selectedVariantId: string | null;
  svgLayerRef: React.MutableRefObject<number | undefined>;
  variants: Variant[];
  onOpenGallery: (index: number) => void;
  onSwipe: (index: number) => void;
  setSelectedGalleryItemIndex: React.Dispatch<React.SetStateAction<number>>;
}

const ImagesGalleryMobile: React.FC<Props> = ({
  selectedGalleryItemIndex,
  productGallery,
  selectedVariantId,
  svgLayerRef,
  variants,
  onOpenGallery,
  onSwipe,
  setSelectedGalleryItemIndex,
}) => {
  const { product } = useProductDetailsHeaderState();
  const $slider = useRef<Slider>(null);

  const sliderOptions = {
    arrows: false,
    autoplay: false,
    draggable: true,
    centerMode: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    afterChange: (index: number) => onSwipe(index),
  };

  useSynchoniseVariantImage({
    productGallery,
    selectedGalleryItemIndex,
    selectedVariantId,
    sliderRef: $slider,
    svgLayerRef,
    variants,
    setSelectedGalleryItemIndex,
  });

  usePreventHorizontalScroll($slider);

  return (
    <div className="relative h-[344px]" data-test="image-section-mobile">
      <div className="relative h-[322px]">
        <Slider {...sliderOptions} ref={$slider}>
          {product.images.map((image, index) => (
            <div
              key={index}
              className="relative h-[322px] cursor-pointer px-2 outline-hidden"
              onClick={() => {
                $slider.current?.slickGoTo(index);
                setSelectedGalleryItemIndex(index);
                onOpenGallery(index);
              }}
            >
              <Image
                className="h-auto w-full rounded-lg"
                loader={image.id === 'test' ? undefined : generalImageLoader}
                src={image.originalSrc}
                priority={index === 0}
                alt={image.altText || product.title}
                fill={true}
                style={{
                  objectFit: 'contain',
                }}
              />
            </div>
          ))}
        </Slider>
      </div>

      <div className="mt-1">
        <CarouselSelector
          images={product.images}
          selectedGalleryItemIndex={selectedGalleryItemIndex}
          onClick={(index) => {
            $slider.current?.slickGoTo(index);
            setSelectedGalleryItemIndex(index);
          }}
        />
      </div>

      <button
        className="absolute bottom-0 right-0 mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-grey-50"
        onClick={() => onOpenGallery(selectedGalleryItemIndex)}
      >
        <IconSearch className="h-5 w-5 text-text-secondary" />
      </button>
    </div>
  );
};

export default ImagesGalleryMobile;
